import { allow } from '../classes/allow';
import local from '../classes/local';
import getUrlParameters from './get.url.parameters';

export default function setLanguage(language = '') {
    allow.aString(language);
    if (language) {
        local.setItem('language', language);
        return;
    }
    const urlParameters = getUrlParameters();
    if (urlParameters.hasOwnProperty('Lang') || urlParameters.hasOwnProperty('lang')) {
        let langParameter = 'en-us';
        langParameter = urlParameters.Lang ? urlParameters.Lang : langParameter;
        langParameter = urlParameters.lang ? urlParameters.lang : langParameter;
        if (langParameter) {
            if (langParameter === 'en-us')
                local.setItem('language', 'English');
            if (langParameter === 'es-mx')
                local.setItem('language', 'Spanish');
            return;
        }
    }
    if (document.documentElement.lang === 'es') {
        local.setItem('language', 'Spanish');
        return;
    }
    if (!local.getItem('language'))
        local.setItem('language', 'English');
}